import Notification from '../base/notification'

let messageInstance

function getMessageInstance () {
	messageInstance = messageInstance || Notification.newInstance()

	return messageInstance
}

function notice (content = '', type, duration = 1.5, onClose = function () {}, render = function () {}) {
	let instance = getMessageInstance()

	instance.notice({
		duration: duration,
		content: `<div class="alert alert-${type}" role="alert">${content}</div>`,
		onClose: onClose,
		render: render,
		type: 'message'
	})
}

export default {
	name: 'Message',
	info (options) {
        return this.message('info', options)
    },
    success (options) {
        return this.message('success', options)
    },
    warning (options) {
        return this.message('warning', options)
    },
    danger (options) {
        return this.message('danger', options)
    },
	message (type, options) {
		if (typeof options === 'string') {
			options = {
				content: options
			}
		}

		return notice(options.content, type, options.duration, options.onClose, options.render)
	}
}



// WEBPACK FOOTER //
// ./src/components/message/index.js